<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ChevronRight } from 'lucide-vue-next'
import { formatDate, type WorkOrderSummary } from '@ck/domain'
import { CkProgress, CkTable } from '@ck/ui'
import CoverThumb from './CoverThumb.vue'

defineProps<{ workOrders: WorkOrderSummary[] }>()
const router = useRouter()

const columns = [
  { key: 'vehicle', label: 'Veículo', width: '1.6fr' },
  { key: 'customer', label: 'Cliente', width: '1fr' },
  { key: 'stage', label: 'Etapa', width: '1.3fr' },
  { key: 'delivery', label: 'Prazo', width: '0.8fr' },
  { key: 'flags', label: '', width: 'auto', align: 'right' as const }
]

function formatDelivery(iso: string | null) { return formatDate(iso) }

function openOrder(id: string) {
  router.push({ name: 'ordem-detalhe', params: { id } })
}
</script>

<template>
  <CkTable :columns="columns" :rows="workOrders" :row-key="(row) => row.id" empty-message="Nenhuma ordem de serviço encontrada.">
    <template #footer><span class="foot-note">{{ workOrders.length }} ordens</span></template>
    <template #default="{ item }: { item: WorkOrderSummary }">
      <button type="button" class="cell vehicle-cell" @click="openOrder(item.id)">
        <CoverThumb :media-id="item.coverMediaId"/>
        <span><strong>{{ item.vehicle.brand }} {{ item.vehicle.model }}</strong><small class="ck-code">{{ item.number }} · {{ item.vehicle.year }}</small></span>
      </button>
      <button type="button" class="cell" @click="openOrder(item.id)">{{ item.customer }}</button>
      <button type="button" class="cell stage-cell" @click="openOrder(item.id)">
        <div class="stage-line"><span>{{ item.currentStage ?? 'Sem etapa ativa' }}</span><span v-if="item.currentStageSequence" class="ck-code fraction">{{ item.currentStageSequence }}/{{ item.stageCount }}</span></div>
        <CkProgress :value="item.progress" :label="`Progresso de ${item.number}`"/>
      </button>
      <button type="button" class="cell" @click="openOrder(item.id)">{{ formatDelivery(item.expectedDelivery) }}</button>
      <button type="button" class="cell flags-cell" @click="openOrder(item.id)">
        <span v-if="item.rejectedItemCount > 0" class="flag">{{ item.rejectedItemCount }} reprov.</span>
        <ChevronRight :size="16" class="chevron"/>
      </button>
    </template>
  </CkTable>
</template>

<style scoped>
.cell { display: flex; align-items: center; border: 0; background: none; padding: 0; font: inherit; color: var(--color-text); text-align: left; cursor: pointer; }
.vehicle-cell { gap: 12px; }
.vehicle-cell strong { display: block; font-size: 14px; }
.vehicle-cell small { display: block; color: var(--color-text-faint); font-size: 11px; margin-top: 1px; }
.stage-cell { flex-direction: column; align-items: stretch; gap: 5px; }
.stage-line { display: flex; justify-content: space-between; font-size: 12.5px; }
.fraction { color: var(--color-text-faint); }
.flags-cell { justify-content: flex-end; gap: 10px; }
.flag { background: var(--ck-fail-bg); color: var(--ck-fail-text); font-weight: 700; font-size: 11.5px; font-family: var(--font-mono); padding: 3px 8px; border-radius: 7px; }
.chevron { color: var(--color-text-faint); }
.foot-note { font-size: 12.5px; color: var(--color-text-faint); }
</style>
